import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_JUSTIFICATIONS_PA_LIST_REQUEST,
  FETCH_JUSTIFICATIONS_PA_LIST_SUCCESS,
  FETCH_JUSTIFICATIONS_PA_LIST_ERROR,
  UPDATE_JUSTIFICATION_PA_REQUEST,
  UPDATE_JUSTIFICATION_PA_SUCCESS,
  UPDATE_JUSTIFICATION_PA_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

/*
 * REQUEST JUSTIFICATIONS PUNCTUAL ADJUST
 */
export const fetchJustificationsPaList =
  (token, param = { inInactive: 2 }) =>
  (dispatch) => {
    dispatch(fetchJustificationsPaListRequest())

    return new Api(token, dispatch)
      .get(API_URL.LIST_JUSTIFICATIONS_PA, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(fetchJustificationsPaListSuccess(response.data.listPresenter))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchJustificationsPaListError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchJustificationsPaListRequest = () => ({
  type: FETCH_JUSTIFICATIONS_PA_LIST_REQUEST,
})

export const fetchJustificationsPaListSuccess = (data) => ({
  type: FETCH_JUSTIFICATIONS_PA_LIST_SUCCESS,
  payload: data,
})

export const fetchJustificationsPaListError = (error) => ({
  type: FETCH_JUSTIFICATIONS_PA_LIST_ERROR,
  payload: error,
})

/*
 * SAVE OR UPDATE JUSTIFICATION PUNCTUAL ADJUST
 */
export const updateJustificationPa =
  (token, values, callback) => (dispatch) => {
    dispatch(updateJustificationPaRequest())

    return new Api(token, dispatch)
      .post(API_URL.SAVE_JUSTIFICATION_PA, values)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateJustificationPaSuccess(response.data))
        dispatch(fetchJustificationsPaList(token))

        if (callback) callback()
      })
      .catch((error) => {
        dispatch(updateJustificationPaError(error))
      })
      .finally(() => dispatch(hideSpinner()))
  }

export const updateJustificationPaRequest = () => ({
  type: UPDATE_JUSTIFICATION_PA_REQUEST,
})

export const updateJustificationPaSuccess = (data) => ({
  type: UPDATE_JUSTIFICATION_PA_SUCCESS,
  payload: data,
})

export const updateJustificationPaError = (error) => ({
  type: UPDATE_JUSTIFICATION_PA_ERROR,
  payload: error,
})

/*
 * REMOVE JUSTIFICATION PUNCTUAL ADJUST
 */
export const removeJustificationPa = (token, id, callback) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.REMOVE_JUSTIFICATION_PA, id)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(fetchJustificationsPaList(token))

      if (callback) callback()
    })
    .catch((error) => {
      dispatch(updateJustificationPaError(error))
    })
    .finally(() => dispatch(hideSpinner()))
